import { Mapper } from '../../../../domain/adapters/mapper.adapter';
import { ListingModel } from '../../../../domain/models/listing.model';
import { GetSingleListingResponse } from '../listings.responses';

export class SingleListingResponseMapper extends Mapper<
  GetSingleListingResponse,
  ListingModel
> {
  mapFrom(param: GetSingleListingResponse): ListingModel {
    const { listing } = param;
    const sortedImages = (listing.images ?? []).slice().sort((a, b) => {
      const indexA = parseInt(a.index, 10);
      const indexB = parseInt(b.index, 10);
      return indexA - indexB;
    });
    return {
      id: listing.id,
      title: listing.title,
      price: parseFloat(listing.price),
      description: listing.description,
      city: listing.city,
      region: listing.region,
      created_at: listing.created_at,
      phone_number: listing.phone_number,
      user: {
        id: listing.user.id,
        name: listing.user.name,
        profileImage: listing.user.profile_image,
      },
      attributes: listing.attributes ?? [],
      images: sortedImages,
      slug: listing.slug,
      category_id: listing.category_id,
      is_archived: !!listing.is_archived,
      has_viber: !!listing.has_viber,
      condition: listing.condition,
    } as ListingModel;
  }
  mapTo(param: ListingModel): GetSingleListingResponse {
    return {
      success: true,
      message: '',
      listing: {
        id: param.id,
        title: param.title,
        description: param.description,
        price: param.price.toString(),
        city: param.city,
        region: param.region,
        created_at: param.created_at,
        phone_number: param.phone_number,
        user: param.user,
        attributes: param.attributes ?? [],
        images: param.images ?? [],
        slug: param.slug,
        category_id: param.category_id,
        is_archived: param.is_archived ? 1 : 0,
        has_viber: param.has_viber ? 1 : 0,
        condition: param.condition,
      },
    };
  }
}
